import { ContextMenu } from "client/CommonComponents";
import AuditDates from "./AuditDates";
import { useEffect, useRef, useState } from "react";
import moment from "moment";
import { AuditsDispatch } from "Store/AssetInventory/AuditDates/AuditDatesDispatch";
import { useDispatch, useSelector } from "react-redux";
import { selectors as userProfileSelectors } from "redux/UserProfile";
import SuccessBee from "../../../assets/images/SuccessBee.svg";
import { CONSTANTS } from "client/utils/constants";
import ConfirmationBee from "../../../assets/images/ConfirmationBee.svg";
import { setAuditCreationSuccess, setAuditDeletionSuccess, setAuditUpdationSuccess  } from "Store/AssetInventory/AuditDates/AuditDatesAction";
import permissions, { isAuthorized } from "client/utils/Permissions";
import { useNavigate } from "react-router-dom";
import { popupInitialData } from "utils";

const AuditDatesContainer = () =>{

    const navigate = useNavigate();


    const [CreateAuditPopup, setCreateAuditPopup] = useState<any>(false)
    const [yearsDropDown, setYearsDropDown] = useState<any>([])
    const [error, setError] = useState<any>({year:"", AuditDateRange:"", auditTrainingDateRange: "", auditReadinessDateRange: ""})
    const [maxDateRange, setMaxDateRange] = useState<any>("")
    const [minDateRange, setMinDateRange] = useState<any>("")
    const [isEditClick, setIsEditClick] = useState<any>(false)
    const [rowValue, setRowValue] = useState<any>("")
    const [deletePopup, setDeletePopup] = useState(false);
    const [isNotEditable, setIsNotEditable] = useState(false);
    const [rowId,setRowId] = useState<any>("");
    const [disableAuditYear, setDisableAuditYear] = useState(false);
    const [existingAuditStartDate, setExistingAuditStartDate] = useState<any>('')
    const [existingAuditEndDate, setExistingAuditEndDate] = useState<any>("")
    const [popupContent, setPopupContent] = useState<any>(popupInitialData)

    const { auditList, userDetails, auditCreatedResponse, auditUpdatedResponse, isAuditDeleted }: any = useSelector((state?: any) => ({
        auditList: state.AssetInventoryAuditDatesReducer.auditList,
        userDetails: userProfileSelectors.getUserDetails(state),
        auditCreatedResponse: state.AssetInventoryAuditDatesReducer.auditCreatedResponse,
        auditUpdatedResponse: state.AssetInventoryAuditDatesReducer.auditUpdatedResponse,
        isAuditDeleted: state.AssetInventoryAuditDatesReducer.isAuditDeleted,
      }));

    useEffect(() => {
        if (userDetails?.permissions?.length && !(isAuthorized(permissions.CreateEditAudit) || isAuthorized(permissions.ViewAudit))) {
            navigate('/assetinventory');
        }
    }, [userDetails?.permissions])

    let initialAudit = {
        cycleId: 0,
        fy: "",
        cycleStartDate: "",
        cycleEndDate: "",
        savedBy: userDetails?.emailId,
        auditReadinessStartDate: "",
        auditReadinessEndDate: "",
        auditTrainingStartDate: "",
        auditTrainingEndDate: "",
      }

    const [auditDetails, setAuditDetails] = useState<any>([])
    const [gridData, setGridData] = useState<any>([])
    
    const dispatch = useDispatch();

    useEffect(() => {
        if(auditList?.length){
            const auditListTemp = auditList?.map((item: any) => ({
                ...item,
                cycleStartDate: item.cycleStartDate ? moment(item.cycleStartDate).format("MM/DD/YYYY") : null,
                cycleEndDate: item.cycleEndDate ? moment(item.cycleEndDate).format("MM/DD/YYYY") : null,
                auditReadinessStartDate: item.auditReadinessStartDate ? moment(item.auditReadinessStartDate).format("MM/DD/YYYY") : null,
                auditReadinessEndDate: item.auditReadinessEndDate ?  moment(item.auditReadinessEndDate).format("MM/DD/YYYY") : null,
                auditTrainingStartDate: item.auditTrainingStartDate ? moment(item.auditTrainingStartDate).format("MM/DD/YYYY") : null,
                auditTrainingEndDate: item.auditTrainingEndDate ? moment(item.auditTrainingEndDate).format("MM/DD/YYYY") : null
            }))
            setGridData(auditListTemp)
        } else {
            setGridData(auditList) 
        }
    },[auditList])

    const dispatchGetAuditDatesList = AuditsDispatch.dispatchGetAuditDatesList(dispatch);
    const dispatchCreateAudit = AuditsDispatch.dispatchCreateAudit(dispatch)
    const dispatchUpdateAudit = AuditsDispatch.dispatchUpdateAudit(dispatch)
    const dispatchDeleteAudit = AuditsDispatch.dispatchDeleteAudit(dispatch)

    const onclickEditAudit = (rowData: any) => {
        setError({ ...error, year: "", AuditDateRange: "", auditTrainingDateRange: "", auditReadinessDateRange: "" })
        setIsEditClick(true)
        setRowValue(rowData?.fy)
        setCreateAuditPopup(true)
        let specificDate = new Date(rowData?.cycleEndDate)
        let currentDate = new Date()
        specificDate.setHours(0, 0, 0, 0);
        currentDate.setHours(0, 0, 0, 0);
        if(specificDate < currentDate){
            setDisableAuditYear(true)
        }else{
            setDisableAuditYear(false)
        }
        setExistingAuditStartDate(rowData?.cycleStartDate)
        setExistingAuditEndDate(rowData?.cycleEndDate)
        let dateRange = [new Date(rowData?.cycleStartDate), new Date(rowData?.cycleEndDate)]
        let auditReadinessDateRange = rowData?.auditReadinessStartDate ? [new Date(rowData?.auditReadinessStartDate), new Date(rowData?.auditReadinessEndDate)] : null
        let auditTrainingDateRange = rowData?.auditTrainingStartDate ? [new Date(rowData?.auditTrainingStartDate), new Date(rowData?.auditTrainingEndDate)] : null
        setAuditDetails({
            ...rowData,
            dateRange: dateRange,
            auditReadinessDateRange: auditReadinessDateRange,
            auditTrainingDateRange: auditTrainingDateRange,
            savedBy: userDetails?.emailId,
            cycleStartDate: rowData.cycleStartDate ? moment(rowData.cycleStartDate).format("YYYY-MM-DD") : null,
            cycleEndDate: rowData.cycleEndDate ? moment(rowData.cycleEndDate).format("YYYY-MM-DD") : null,
            auditReadinessStartDate: rowData.auditReadinessStartDate ? moment(rowData.auditReadinessStartDate).format("YYYY-MM-DD") : null,
            auditReadinessEndDate: rowData.auditReadinessEndDate ? moment(rowData.auditReadinessEndDate).format("YYYY-MM-DD") : null,
            auditTrainingStartDate: rowData.auditTrainingStartDate ? moment(rowData.auditTrainingStartDate).format("YYYY-MM-DD") : null,
            auditTrainingEndDate: rowData.auditTrainingEndDate ? moment(rowData.auditTrainingEndDate).format("YYYY-MM-DD") : null
        })
        let currentYear = new Date().getFullYear()

        if (rowData?.fy < currentYear) {
            setIsNotEditable(true)
        }
        else {
            setIsNotEditable(false)
        }
    }

    useEffect(() => {
        if (rowValue && isEditClick) {
            let currentYear = new Date().getFullYear();
            let year = rowValue
            if (currentYear == year) {
                let specificDate = new Date(existingAuditStartDate)
                let currentDate = new Date()
                specificDate.setHours(0, 0, 0, 0);
                currentDate.setHours(0, 0, 0, 0);
                if (specificDate > currentDate) {
                    setMinDateRange(new Date())
                } else {
                    setMinDateRange(new Date(existingAuditStartDate))
                }

            } else {
                setMinDateRange(new Date(year, 0, 1))
            }
            setMaxDateRange(new Date(year, 11, 31))

        }
    }, [rowValue])

    const onclickDeleteAudit = (rowData: any) => {
        setDeletePopup(true)
        setRowValue(rowData?.fy)
        setRowId(rowData?.cycleId)
    }

    const CustomCell = (rowData: any) => {
        const [showContextualMenu, setShowContextualMenu] = useState(false);
        const onShowContextualMenu = (ev: React.MouseEvent<HTMLElement>) => {
            ev.preventDefault();
            setShowContextualMenu(true);
          }

          const menuItems = [
            {
              key: 'Edit',
              text: 'Edit',
              disabled: !isAuthorized(permissions.CreateEditAudit),
              onClick: () => onclickEditAudit(rowData),       
            },
            {
              key: 'Delete',
              text: 'Delete',
              disabled: !isAuthorized(permissions.CreateEditAudit),
              onClick: () => onclickDeleteAudit(rowData),
            },
        ]
      
        const onHideContextualMenu = () => setShowContextualMenu(false);
        const linkRef = useRef(null);
        return (
            <>
            <ContextMenu 
                items={menuItems}
                hidden={showContextualMenu}
                target={linkRef}
                onItemClick = {onHideContextualMenu}
                onDismiss = {onHideContextualMenu}
                className='grid-context-menu'
             data-attribute="AuditDates_container_Default_ContextMenu">          
            <a className="context-menu" ref={linkRef}  href="/" onClick={onShowContextualMenu}><span className='fa fa-ellipsis-h'> </span> </a>       
            </ContextMenu>  
            </>
        )
    }

    const hideDialogSubmit = () => {
        setSubmitPopupcontent({ ...submitPopupcontent, isDialogVisible: false })
        dispatch(setAuditCreationSuccess({}))
        dispatch(setAuditUpdationSuccess({}))
        dispatch(setAuditDeletionSuccess(''))
      };
    
      const popupOutlinebtnOnclickCancel = () => {
        hideDialogSubmit();
        setRowValue('')
      };

    const [submitPopupcontent, setSubmitPopupcontent] = useState<any>({
        title: "",
        isDialogVisible: false,
        isTitleWarning: false,
        subtextcontent: "",
        outlineBtnText: "",
        popupOutlinebtnOnclick: () => { },
        pupPrimarybtnOnclick: () => {},
        isSingleConfirmationBtn: false,
        isCommentboxVisible: false,
        isCompletedReportVisible: false,
        titleImg: "",
        isCommentBoxRequire: false,
        outlineBtnnavigateTo: "",
        primaryBtnnavigateTo: "",
        actionby: "",
        value: 0,
        comments: "",
      });

    const PopupMessage = (decriptionTxt : any, title: any, imgBee: any) => {
        setSubmitPopupcontent({
            ...submitPopupcontent,
            titleImg: imgBee,
            title: title,
            isDialogVisible: true,
            isTitleWarning: false,
            subtextcontent: decriptionTxt,
            outlineBtnText: "Close",
            popupOutlinebtnOnclick: popupOutlinebtnOnclickCancel,
            isSingleConfirmationBtn: true,
          });
    
    }  

    
  useEffect(() => {
    if(auditCreatedResponse?.isValid != undefined){
        if (auditCreatedResponse?.isValid) {
            setCreateAuditPopup(false)
            dispatchGetAuditDatesList("")
          let decriptionTxt = (<>
            <p>Audit created successfully</p>
          </>);
          PopupMessage(decriptionTxt, CONSTANTS.TITLE_SUCCESS, SuccessBee)
        } 
        else {
          let decriptionTxt = (<>
            <p>{auditCreatedResponse?.validationMessage}</p>
          </>);
          PopupMessage(decriptionTxt, CONSTANTS.TITLE_CONFIRMATION, ConfirmationBee)
        }
    }
  }, [auditCreatedResponse])

  useEffect(() => {
    if(auditUpdatedResponse?.isValid != undefined){
        if (auditUpdatedResponse?.isValid) {
            setCreateAuditPopup(false)
            dispatchGetAuditDatesList("")
          let decriptionTxt = (<>
            <p>Audit Updated successfully</p>
          </>);
          PopupMessage(decriptionTxt, CONSTANTS.TITLE_SUCCESS, SuccessBee)
        } 
        else {
          let decriptionTxt = (<>
            <p>{auditUpdatedResponse.validationMessage}</p>
          </>);
          PopupMessage(decriptionTxt, CONSTANTS.TITLE_CONFIRMATION, ConfirmationBee)
        }
    }
  }, [auditUpdatedResponse])

  useEffect(() => {
    setRowId("");
    if (isAuditDeleted === CONSTANTS.SUCCESS) {
        setCreateAuditPopup(false)
        dispatchGetAuditDatesList("")
      let decriptionTxt = (<>
        <p>Audit Deleted successfully</p>
      </>);
      PopupMessage(decriptionTxt, CONSTANTS.TITLE_SUCCESS, SuccessBee)
    } 
    else if (isAuditDeleted === CONSTANTS.FAILED) {
      let decriptionTxt = (<>
        <p>Error occured while Deleting the Audit.</p>
      </>);
      PopupMessage(decriptionTxt, CONSTANTS.TITLE_CONFIRMATION, ConfirmationBee)
    }
  }, [isAuditDeleted])

    useEffect(() => {
        if(auditUpdatedResponse?.isValid != undefined){
            setCreateAuditPopup(false)
            dispatchGetAuditDatesList("")
        }
    }, [auditUpdatedResponse]);

    useEffect(() => {
        if(isAuditDeleted){
            dispatchGetAuditDatesList("")
        }
    }, [isAuditDeleted]);
    
    
    useEffect(() => {
        document.getElementsByClassName('content-wrapper')[0].scrollTop = 0;
        let year = new Date().getFullYear()
         const years: any =[]
         for(let i=0; i<5; i++){
            years.push({key: year.toString(), text: year.toString(), value: year.toString(),})
            year++;
         }
         setYearsDropDown(years)
         dispatchGetAuditDatesList("")
    }, []);

    const CreateNewAuditClick = () => {
        setAuditDetails(initialAudit)
        setCreateAuditPopup(true)
        setError({...error,year:"", AuditDateRange:"", auditTrainingDateRange: "", auditReadinessDateRange: ""})
        setMaxDateRange("")
        setMinDateRange("")
        setIsEditClick(false)
        setIsNotEditable(false)
        setDisableAuditYear(false)
    };

    const hidePopup = () => {
        setCreateAuditPopup(false)
        setDisableAuditYear(false)
    };

    const onChangeAuditYear = (event: any, year: any) => {
        let currentYear = new Date().getFullYear();
        if(currentYear == year?.text){
            setMinDateRange(new Date())
        }else{
            setMinDateRange(new Date(year?.text, 0, 1))
        }
       
       setMaxDateRange(new Date(year?.text, 11, 31))
        setAuditDetails({...auditDetails, fy: year.text, dateRange: []})
    }

    const onDateChange = (e: any, item: any) => {
        let fromDate = e?.length ? moment(new Date(e[0]?.toString())).format('YYYY-MM-DD') : "";
        let toDate = e?.length ? moment(new Date(e[1]?.toString())).format('YYYY-MM-DD') : "";
        if (fromDate && toDate) {
            if (item == "auditDate") {
                let existingAuditStartDateTemp = new Date(existingAuditStartDate)
                let currentDateTemp = new Date()
                existingAuditStartDateTemp.setHours(0, 0, 0, 0);
                currentDateTemp.setHours(0, 0, 0, 0);
                if(isEditClick && existingAuditStartDateTemp <= currentDateTemp && existingAuditStartDateTemp != e[0] ){
                    setPopupContent({
                        ...popupContent,
                        title: "INFORMATION",
                        titleImg: ConfirmationBee,
                        isDialogVisible: true,
                        isTitleWarning: false,
                        subtextcontent: "Audit Start Date cannot be changed for already started Audit.",
                        outlineBtnText: "Ok",
                        isSingleConfirmationBtn: true,
                        popupOutlinebtnOnclick: () => {
                            hideDialogComplete()
                            setAuditDetails({ ...auditDetails, cycleStartDate: existingAuditStartDate, cycleEndDate: existingAuditEndDate, dateRange: [new Date(existingAuditStartDate), new Date(existingAuditEndDate)] })
                        }
                    });
                }else{
                setError({ ...error, AuditDateRange: "" })
                setAuditDetails({ ...auditDetails, cycleStartDate: fromDate, cycleEndDate: toDate, dateRange: e })
                }
            } else if (item == "auditReadinessDate") {
                setError({ ...error, auditReadinessDateRange: "" })
                setAuditDetails({ ...auditDetails, auditReadinessStartDate: fromDate, auditReadinessEndDate: toDate, auditReadinessDateRange: e })
            } else {
                setError({ ...error, auditTrainingDateRange: "" })
                setAuditDetails({ ...auditDetails, auditTrainingStartDate: fromDate, auditTrainingEndDate: toDate, auditTrainingDateRange: e })
            }
        }
        else {
            if (item == "auditDate") {
                setAuditDetails({ ...auditDetails, cycleStartDate: fromDate, cycleEndDate: toDate, dateRange: ["", ""] })
            } else if (item == "auditReadinessDate") {
                setAuditDetails({ ...auditDetails, auditReadinessStartDate: fromDate, auditReadinessEndDate: toDate, auditReadinessDateRange: ["", ""] })
            } else {
                setAuditDetails({ ...auditDetails, auditTrainingStartDate: fromDate, auditTrainingEndDate: toDate, auditTrainingDateRange: ["", ""] })
            }

        }
    }

    const validateAudit = () => {
        let isValid = true;
        let error: any = {}
        if (!auditDetails?.fy) {
            error.year = "Please provide year"
            isValid = false;
        }
        if (!auditDetails?.cycleStartDate || !auditDetails?.cycleEndDate) {
            error.AuditDateRange = "Please provide Audit Start & End Date"
            isValid = false;
        }
        if (!auditDetails?.auditReadinessStartDate || !auditDetails?.auditReadinessEndDate) {
            error.auditReadinessDateRange = "Please provide Audit Readiness Start & End Date"
            isValid = false;
        }
        if (!auditDetails?.auditTrainingStartDate || !auditDetails?.auditTrainingEndDate) {
            error.auditTrainingDateRange = "Please provide Audit Training Start & End Date"
            isValid = false;
        }
        setError(error)
        return isValid;
    }

    const handleSubmitAudit = (e: any) => {
        if(isNotEditable){
            setCreateAuditPopup(false)
            let decriptionTxt = (<>
                <p>Only current and future Audit dates can be Edited</p>
              </>);
              PopupMessage(decriptionTxt, CONSTANTS.TITLE_CONFIRMATION, ConfirmationBee)
            return;
        }

        const isValid = validateAudit()
        if(isValid){
        if(isEditClick){
            dispatchUpdateAudit({...auditDetails})
        }
        else{
            dispatchCreateAudit({...auditDetails})
        }
        }
    }

    const deleteAuditDate = () => {
        let sortedauditList = JSON.parse(JSON.stringify(auditList));

        let currentYear = new Date().getFullYear()

        if(rowValue < currentYear){
            setDeletePopup(false)
            let decriptionTxt = (<>
                <p>Only current and future Audit dates can be deleted</p>
              </>);
              PopupMessage(decriptionTxt, CONSTANTS.TITLE_CONFIRMATION, ConfirmationBee)
            return
        }

        sortedauditList?.map((item: any) => {
            if(item?.fy == rowValue && item?.cycleId == rowId){
                dispatchDeleteAudit({...item})
                setDeletePopup(false)
            }
        })
    }

    const hideDialogComplete = () => {
        setPopupContent({ ...popupContent, isDialogVisible: false })
    };

    return <AuditDates  
                CustomCell={CustomCell}
                CreateAuditPopup={CreateAuditPopup}
                hidePopup={hidePopup}
                CreateNewAuditClick={CreateNewAuditClick}
                yearsDropDown={yearsDropDown}
                onChangeAuditYear={onChangeAuditYear}
                onDateChange={onDateChange}
                handleSubmitAudit={handleSubmitAudit}
                auditList={auditList}
                auditDetails={auditDetails}
                maxDateRange={maxDateRange}
                minDateRange={minDateRange}
                error={error}
                isEditClick={isEditClick}
                submitPopupcontent={submitPopupcontent}
                deleteAuditDate={deleteAuditDate}
                setDeletePopup={setDeletePopup}
                deletePopup={deletePopup}
                isNotEditable= {isNotEditable}
                gridData={gridData}
                disableAuditYear = {disableAuditYear}
                hideDialogComplete = {hideDialogComplete}
                popupContent = {popupContent}
            />
}

export default AuditDatesContainer;